<template>
    <v-col cols="12" sm="6" md="6" lg="8" xl="8">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-row justify="end" dense>
                    <v-col cols="12" md="6" lg="3">
                        <v-menu
                            v-model="menuFrom"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template #activator="{on}">
                                <v-text-field
                                    :value="filters.ordersPerImposition__gte"
                                    label="Od"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    clearable
                                    solo
                                    hide-details
                                    v-on="on"
                                    @input="changeFilter()"
                                    @click:clear="clearFilter('ordersPerImposition__gte')"
                                />
                            </template>
                            <v-date-picker
                                v-model="filters.ordersPerImposition__gte"
                                first-day-of-week="1"
                                @change="changeFilter()"
                                @input="menuFrom = false"
                            />
                        </v-menu>
                    </v-col>
                    <v-col cols="12" md="6" lg="3">
                        <v-menu
                            v-model="menuTo"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template #activator="{on}">
                                <v-text-field
                                    :value="filters.ordersPerImposition__lte"
                                    label="Do"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    clearable
                                    solo
                                    hide-details
                                    v-on="on"
                                    @input="changeFilter()"
                                    @click:clear="clearFilter('ordersPerImposition__lte')"
                                />
                            </template>
                            <v-date-picker
                                v-model="filters.ordersPerImposition__lte"
                                first-day-of-week="1"
                                @change="changeFilter()"
                                @input="menuTo = false"
                            />
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-tabs
                                v-model="tabs"
                                background-color="transparent"
                                slider-color="blue"
                                @change="changeTab"
                            >
                                <v-tab>
                                    tabela
                                </v-tab>
                                <v-tab>
                                    wykres
                                </v-tab>
                                <v-tabs-items v-model="tabs">
                                    <v-divider />
                                    <v-tab-item>
                                        <v-card
                                            flat
                                            :loading="actionLoading.getNumberOfOrders || actionLoading.exportReport"
                                        >
                                            <v-row justify="end">
                                                <v-col cols="auto">
                                                    <v-btn
                                                        text
                                                        small
                                                        data-sentry-label="Eksportuj"
                                                        :loading="actionLoading.exportReport"
                                                        @click="exportReport"
                                                    >
                                                        <v-icon small left color="green">
                                                            mdi-file-excel
                                                        </v-icon>
                                                        Eksportuj
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-data-table
                                                            :headers="numberOfOrdersHeaders"
                                                            :items="numberOfOrdersItems"
                                                            dense
                                                            :mobile-breakpoint="0"
                                                            no-data-text="Brak danych"
                                                            hide-default-footer
                                                        >
                                                            <template #item.machine="{item}">
                                                                <template v-if="item.machine === 'total'">
                                                                    <strong>OGÓŁEM:</strong>
                                                                </template>
                                                                <template v-else>
                                                                    {{ item.machine }}
                                                                </template>
                                                            </template>
                                                        </v-data-table>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card flat>
                                            <v-row justify="end">
                                                <v-col cols="auto">
                                                    <v-btn
                                                        text
                                                        small
                                                        data-sentry-label="Generuj raport"
                                                        :loading="actionLoading.generateReport"
                                                        @click="generateReport"
                                                    >
                                                        <v-icon small left color="red">
                                                            mdi-file-pdf
                                                        </v-icon>
                                                        Generuj raport
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-card
                                                width="100%"
                                                height="500px"
                                                class="d-flex flex-column"
                                            >
                                                <v-card-text style="height: 99.9%; width: 100%; position: relative">
                                                    <canvas ref="NumberOfOrdersPerImpositionChart" />
                                                </v-card-text>
                                            </v-card>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tabs>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'
import { Chart, BarController, LineController, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Tooltip, Legend } from 'chart.js'
import { jsPDF } from 'jspdf'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import html2canvas from 'html2canvas'
import { format } from 'date-fns'
import './../../../../public/fonts/roboto/Roboto-Light.js'

export default {
    name: 'NumberOfOrdersPerImposition',
    mixins: [filters, dateFormatter],
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            chart: null,
            chartData: [],
            menuFrom: false,
            menuTo: false,
            actionLoading: {
                getNumberOfOrders: false,
                generateReport: false,
                exportReport: false,
            },
            tabs: 0,
            numberOfOrdersHeaders: [
                { text: 'Maszyna', value: 'machine' },
                { text: 'Ilość montaży', value: 'numberOfImpositions' },
                { text: 'Ilość zamówień', value: 'numberOfOrders' },
                { text: 'Sprawność', value: 'efficiency' },
            ],
        }
    },
    computed: {
        numberOfOrdersItems() {
            return this.$store.state.dashboard.dashboard.numberOfOrdersPerImposition
        },
        user() {
            return this.$store.state.user
        },
    },
    mounted() {
        this.filters.ordersPerImposition__lte = format(new Date(), 'YYYY-MM-DD')
        this.filters.ordersPerImposition__gte = format(new Date(new Date().setDate(new Date().getDate()-1)), 'YYYY-MM-DD')
        this.getDashboard()
    },
    destroyed() {
        if (this.chart !== null) {
            this.chart.destroy()
        }
    },
    methods: {
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query ? '?' + query.slice(1) : ''
        },
        filterQueryForReport() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    if (item == 'ordersPerImposition__gte') {
                        query = query.concat('&', 'createdAt__gte=', filters[item])
                        continue
                    }
                    if (item == 'ordersPerImposition__lte') {
                        query = query.concat('&', 'createdAt__lte=', filters[item])
                        continue
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query ? '?' + query.slice(1) : ''
        },
        getDashboard() {
            this.actionLoading.getNumberOfOrders = true
            this.$store.dispatch('dashboard/getDashboardItem', {
                item: this.widget,
                paginate: '',
                query: this.filterQuery()
            })
                .then(() => {
                    if (this.chart !== null) {
                        this.setChartData()
                    }
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getNumberOfOrders = false
                })
        },
        changeTab() {
            if (this.tabs === 1) {
                setTimeout(() => {
                    (!this.chart && this.setDiagram())
                    this.setChartData()
                }, 100)
            }
        },
        setDiagram() {
            Chart.register(
                BarController,
                BarElement,
                CategoryScale,
                ChartDataLabels,
                Legend,
                LinearScale,
                LineController,
                LineElement,
                PointElement,
                Tooltip
            )
            const chartContainer = this.$refs.NumberOfOrdersPerImpositionChart

            this.chart = new Chart(chartContainer, {
                type: 'line',
                plugins: [
                    ChartDataLabels,
                ],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom',
                        },
                        datalabels: {
                            display: false,
                        }
                    },
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            ticks: {
                                stepSize: 20,
                            },
                        },
                        y1: {
                            min: 0,
                            max: 100,
                            ticks: {
                                stepSize: 10,
                                callback(value) {
                                    return value + '%'
                                }
                            },
                            grid: {
                                display: false,
                            },
                            position: 'right',
                        },
                    },
                },
                data: {
                    labels: this.chartData.map(item => item.machine),
                },
            })
        },
        setChartData() {
            this.chartData = this.numberOfOrdersItems.slice(0, -1)

            this.chart.data.labels = this.chartData.map(item => item.machine),
            this.chart.data.datasets = [{
                type: 'bar',
                label: 'Ilość Montaży',
                data: this.chartData.map(item => item.numberOfImpositions),
                backgroundColor: '#4e81bd',
                borderWidth: 0,
                borderRadius: 5,
            }, {
                type: 'bar',
                label: 'Ilość Zamówień',
                data: this.chartData.map(item => item.numberOfOrders),
                backgroundColor: '#c0504d',
                borderWidth: 0,
                borderRadius: 5,
            }, {
                type: 'line',
                label: 'Sprawność',
                data: this.numberOfOrdersItems.map(item => item.efficiency),
                borderColor: '#adc778',
                backgroundColor: '#adc778',
                borderWidth: 4,
                fill: false,
            }]
            if (this.$refs.NumberOfOrdersPerImpositionChart) this.chart.update()
        },
        generateReport() {
            this.actionLoading.generateReport = true

            html2canvas(this.$refs.NumberOfOrdersPerImpositionChart)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/png'),
                        doc = new jsPDF({
                            orientation: 'landscape'
                        })

                    doc.setFont('Roboto-Light')
                    doc.text(this.widget.body.title, 10, 10)
                    doc.addImage(imgData, 'PNG', 40, 40, 206, 97)
                    doc.setFontSize(10)
                    doc.text( `Wygenerowano: ${this.formatDate(new Date())}`, 10, 200)

                    window.open(doc.output('bloburl'), '_blank')
                    this.actionLoading.generateReport = false
                })
                .catch(() => {
                    this.actionLoading.generateReport = false
                })
        },
        exportReport() {
            this.actionLoading.exportReport = true
            this.$store.dispatch('dashboard/generateNumberOfOrdersPerImpositionReport', {
                userEmail: this.user.userEmail,
                query: this.filterQueryForReport()
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.exportReport = false
                })
        },
        changeFilter() {
            this.getDashboard()
        },
    },
}
</script>
